import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles.css";

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggle = () => setMenuOpen(open => !open);
  const handleLinkClick = () => setMenuOpen(false);

  return (
    <header>
      <div className="container">
        <div className="logo">
          <Link to="/">ZEMAXI</Link>
        </div>
        <nav className={menuOpen ? 'open' : ''}>
          <ul>
            <li><Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={handleLinkClick}>Home</Link></li>
            <li><Link to="/about" className={location.pathname === "/about" ? "active" : ""} onClick={handleLinkClick}>About</Link></li>
            <li><Link to="/stream" className={location.pathname === "/stream" ? "active" : ""} onClick={handleLinkClick}>Stream</Link></li>
            <li><Link to="/reviews" className={location.pathname === "/reviews" || location.pathname === "/games" ? "active" : ""} onClick={handleLinkClick}>Reviews</Link></li>
            <li><Link to="/videos" className={location.pathname === "/videos" ? "active" : ""} onClick={handleLinkClick}>Videos</Link></li>
            <li><Link to="/tools" className={location.pathname === "/tools" || location.pathname === "/shop" ? "active" : ""} onClick={handleLinkClick}>Tools</Link></li>
            <li><Link to="/contact" className={location.pathname === "/contact" ? "active" : ""} onClick={handleLinkClick}>Contact</Link></li>
            <li><Link to="/streamers" className={`nav-gold-link ${location.pathname === "/streamers" ? "active" : ""}`} onClick={handleLinkClick}><i className="fas fa-user"></i> Streamers</Link></li>
          </ul>
        </nav>
        <div className={`menu-toggle${menuOpen ? ' open' : ''}`} onClick={handleToggle}>
          <i className="fas fa-bars"></i>
        </div>
      </div>
    </header>
  );
}
